import * as React from 'react';

interface TabsContextType {
  value: string;
  onValueChange: (val: string) => void;
}
const TabsContext = React.createContext<TabsContextType>({
  value: '',
  onValueChange: () => {},
});

export function Tabs({
  value,
  onValueChange,
  defaultValue = '',
  className = '',
  children,
}: {
  value?: string;
  onValueChange?: (val: string) => void;
  defaultValue?: string;
  className?: string;
  children: React.ReactNode;
}) {
  const [internalVal, setInternalVal] = React.useState(defaultValue);
  const currentVal = value !== undefined ? value : internalVal;
  const handleChange = onValueChange || setInternalVal;

  return (
    <TabsContext.Provider value={{ value: currentVal, onValueChange: handleChange }}>
      <div className={`shadcn-tabs ${className}`.trim()}>{children}</div>
    </TabsContext.Provider>
  );
}

export function TabsList({
  className = '',
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return <div className={`shadcn-tabs-list ${className}`.trim()}>{children}</div>;
}

export function TabsTrigger({
  value,
  className = '',
  children,
}: {
  value: string;
  className?: string;
  children: React.ReactNode;
}) {
  const ctx = React.useContext(TabsContext);
  const isActive = ctx.value === value;
  return (
    <button
      type="button"
      role="tab"
      aria-selected={isActive}
      className={`shadcn-tabs-trigger ${isActive ? 'active' : ''} ${className}`.trim()}
      onClick={() => ctx.onValueChange(value)}
    >
      {children}
    </button>
  );
}

export function TabsContent({
  value,
  className = '',
  children,
}: {
  value: string;
  className?: string;
  children: React.ReactNode;
}) {
  const ctx = React.useContext(TabsContext);
  if (ctx.value !== value) return null;
  return <div className={`shadcn-tabs-content ${className}`.trim()}>{children}</div>;
}
